import PropTypes from 'prop-types';

const { Component } = React;

class Tabs extends Component {
    constructor(props) {
        super(props);

        this.tabs = React.createRef();

        // this._bind('updateFilters');
    }

    updateFilters(newRoomType) {
        return event => {
            event.preventDefault();

            const { ...filters } = this.props.filters;

            if (filters.roomType !== newRoomType) {
                filters.roomType = newRoomType;

                this.props.updateFilters(filters);

                // const headerMiddle = 34;
                // const tabs = this.tabs.current;
                // const resortMenu = document.getElementById('resort-menu').offsetHeight;
                // const viewportOffset = tabs.getBoundingClientRect().top + document.documentElement.scrollTop;

                // if (window.innerWidth > 767) {
                //     window.scrollTo({top: viewportOffset - (resortMenu + headerMiddle + 5), behavior: 'smooth'});
                // }
            }
        };
    }

    render() {
        const {
            averageRate = {},
            status,
            filters = {},
            className = ''
        } = this.props;
        const { roomType = 'BUTLER' } = filters;

        let {
            butlerRate = 0,
            clubRate = 0,
            luxuryRate = 0,
            loveNestRate = 0,
            lowestRate = 0
        } = averageRate;

        const isTransfer = window.location.pathname === '/luxury-transfers/';

        if (isTransfer) {
            luxuryRate = 0;
            loveNestRate = 0;
            lowestRate = 0;
        }

        const levelHeading = {
            LOVENEST: {
                label: 'Love Nest Butler Suites',
                rate: butlerRate
            },
            BUTLER: {
                label: 'Butler',
                rate: clubRate
            },
            CLUB: {
                label: 'Club',
                rate: luxuryRate
            },
            LUXURY: {
                label: 'Luxury',
                rate: loveNestRate
            },
            ALL: {
                label: 'View All',
                rate: lowestRate
            }
        }[roomType];

        return (
            <div className={`rs-banner-tabs ${className}`} ref={this.tabs}>
                <div className="container">
                    {/* Mobile select */}
                    <div className="selectContainer visible-xs">
                        <a className="valueText rs-mob-sekect" href="#">
                            {(levelHeading.label || '')}{' '}
                        </a>

                        <ul className="selectList">
                            {loveNestRate > 0 && (
                                <li
                                    className={
                                        roomType === 'LOVENEST' ? 'active' : ''
                                    }
                                >
                                    <a
                                        className="rs-mob-sekect"
                                        data-toggle="tab"
                                        href="#love-nest"
                                        onClick={this.updateFilters('LOVENEST')}
                                    >
                                        Love Nest Bulter Suites{' '}
                                    </a>
                                </li>
                            )}
                            {butlerRate > 0 && (
                                <li
                                    className={
                                        roomType === 'BUTLER' ? 'active' : ''
                                    }
                                >
                                    <a
                                        className="rs-mob-sekect"
                                        data-toggle="tab"
                                        href="#butler-level"
                                        onClick={this.updateFilters('BUTLER')}
                                    >
                                        Butler Level{' '}
                                    </a>
                                </li>
                            )}
                            {clubRate > 0 && (
                                <li
                                    className={
                                        roomType === 'CLUB' ? 'active' : ''
                                    }
                                >
                                    <a
                                        className="rs-mob-sekect"
                                        data-toggle="tab"
                                        href="#club-level"
                                        onClick={this.updateFilters('CLUB')}
                                    >
                                        Club Level{' '}
                                    </a>
                                </li>
                            )}
                            {luxuryRate > 0 && (
                                <li
                                    className={
                                        roomType === 'LUXURY' ? 'active' : ''
                                    }
                                >
                                    <a
                                        className="rs-mob-sekect"
                                        data-toggle="tab"
                                        href="#luxury-level"
                                        onClick={this.updateFilters('LUXURY')}
                                    >
                                        Luxury Level{' '}
                                    </a>
                                </li>
                            )}
                            {lowestRate > 0 && (
                                <li
                                    className={
                                        roomType === 'ALL' ? 'active' : ''
                                    }
                                >
                                    <a
                                        className="rs-mob-sekect"
                                        data-toggle="tab"
                                        href="#view-all"
                                        onClick={this.updateFilters('ALL')}
                                    >
                                        View All{' '}
                                    </a>
                                </li>
                            )}
                        </ul>
                        <input id="select" type="hidden" />
                    </div>

                    {/*
                        <!--END Mobile select -->
                    */}

                    <ul className="nav nav-pills hidden-xs">
                        {status === 'loading' && [
                            <li key="skeleton-1">
                                <a className="rs-price-tabs">
                                    <span className="ib" />
                                </a>
                            </li>,
                            <li key="skeleton-2">
                                <a className="rs-price-tabs">
                                    <span className="ib" />
                                </a>
                            </li>,
                            <li key="skeleton-3">
                                <a className="rs-price-tabs">
                                    <span className="ib" />
                                </a>
                            </li>
                        ]}
                        {loveNestRate > 0 && (
                            <li
                                className={
                                    roomType === 'LOVENEST' ? 'active' : ''
                                }
                            >
                                <a
                                    className="rs-price-tabs"
                                    data-toggle="tab"
                                    href="#love-nest"
                                    onClick={this.updateFilters('LOVENEST')}
                                >
                                    <p className="rs-logo-lovenest">
                                        <i className="ic ic ic-logo-lovenest-full" />
                                    </p>
                                    {/*
                                <p class="rs-price">
                                    <span className="ib" />
                                </p>
                                */}
                                </a>
                            </li>
                        )}
                        {butlerRate > 0 && (
                            <li
                                className={
                                    roomType === 'BUTLER' ? 'active' : ''
                                }
                            >
                                <a
                                    className="rs-price-tabs"
                                    data-toggle="tab"
                                    href="#butler-level"
                                    onClick={this.updateFilters('BUTLER')}
                                >
                                    <h3>
                                        butler{' '}
                                        <span className="show">level</span>
                                    </h3>
                                </a>
                            </li>
                        )}
                        {clubRate > 0 && (
                            <li className={roomType === 'CLUB' ? 'active' : ''}>
                                <a
                                    className="rs-price-tabs"
                                    data-toggle="tab"
                                    href="#club-level"
                                    onClick={this.updateFilters('CLUB')}
                                >
                                    <h3>
                                        club <span className="show">level</span>
                                    </h3>
                                </a>
                            </li>
                        )}
                        {luxuryRate > 0 && (
                            <li
                                className={
                                    roomType === 'LUXURY' ? 'active' : ''
                                }
                            >
                                <a
                                    className="rs-price-tabs"
                                    data-toggle="tab"
                                    href="#luxury-level"
                                    onClick={this.updateFilters('LUXURY')}
                                >
                                    <h3>
                                        luxury{' '}
                                        <span className="show">level</span>
                                    </h3>
                                </a>
                            </li>
                        )}
                        {lowestRate > 0 && (
                            <li className={roomType === 'ALL' ? 'active' : ''}>
                                <a
                                    className="rs-price-tabs"
                                    data-toggle="tab"
                                    href="#view-all"
                                    onClick={this.updateFilters('ALL')}
                                >
                                    <h3>
                                        view <span className="show">all</span>
                                    </h3>
                                </a>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        );
    }
}

Tabs.propTypes = {
    updateFilters: PropTypes.func,
    className: PropTypes.string
};

Tabs.defaultValue = {
    updateFilters: () => {},
    className: ''
};

export default Tabs;
